import {NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";
import {InputGroupComponent} from "./input-group.component";
import {TranslateModule} from "@ngx-translate/core";
import {MatIconModule} from "@angular/material/icon";
import {ButtonModule} from "../button/button.module";

@NgModule({
  declarations: [ InputGroupComponent ],
  imports: [ CommonModule, TranslateModule, MatIconModule, ButtonModule ],
  exports: [ InputGroupComponent ],
})
export class InputGroupModule {}